// import vuexStoreFactory from "@/_util/vuex-store-factory"
// let factory = new vuexStoreFactory();
// import config from "@/_store/modules/credentials-config"
/* eslint-disable */ 
import moment from "moment"
import jwt_decode from 'jwt-decode'
import vue from 'vue'

export default {
    // mixins : [factory.generateMixin(config)],
    created(){

    },
    data() {
        return {
          // globalCredentialCache : {},
        }
    },
    computed : {
      globalCredentialCache : {
        get : function() {
          // ;
          return this.$store.state.credentialCache
        },
        set : function (value) {
          // ;
          this.$store.commit("credentialCache", value);
        }
      }
    },
    methods : {
      addCredentials(id, data)
      {
        var expires_on = moment().add(data.expires_in, 'seconds').format()
        if(!id || !data || !expires_on){
          throw "This method needs the following parameters (id, data, expires_on)."
        }
        var changes = {};

        changes[id] = Object.assign(data, {"$expires_on" : expires_on});
        //this.globalCredentialCache = Object.assign(this.globalCredentialCache, changes);
        vue.set(this,"globalCredentialCache",Object.assign(this.globalCredentialCache, changes));
        this.$emit("credentials-changed", this.globalCredentialCache);
        return this.getCredentials(id);
      },
      deleteCredentials(id)
      {
        var changes = {};
        changes[id] = null;
        this.globalCredentialCache = Object.assign(this.globalCredentialCache, changes);
      },
      getCredentials(id)
      {
        // 
        var cred = this.globalCredentialCache[id];
        if(!!cred && moment(cred.$expires_on) < moment())
        {
          this.deleteCredentials(id);
          return null;
        }
        if(!cred)
        {
          return null;
        }
        var cred = this.globalCredentialCache[id];
        var decode = jwt_decode(cred.access_token);
        return Object.assign(cred, {'jwt-decode': decode});
      }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/credentials-mixin.js